<template>
  <div class="relative px-8 pt-6 pb-8 mb-2 bg-white rounded-md border model-item border-line">
    <a v-show="false" ref="fileDownload"></a>
    <div class="flex justify-between">
      <div class="flex items-center">
        <h1 class="text-xl font-semibold">{{ model.name }}</h1>
      </div>
      <div class="flex">
        <button class="mr-3 cs-icon-btn clear">
          <i class="flex text-2xl fi fi-rr-cloud-download-alt" @click="onDownload"></i>
        </button>
        <!-- <button class="mr-3 cs-icon-btn clear" @click="onShowCompanys">
          <i class="flex text-2xl fi fi-rr-building"></i>
        </button> -->
        <button class="cs-icon-btn clear" @click="onTrash">
          <i class="flex text-2xl fi fi-rs-trash"></i>
        </button>
      </div>
    </div>
    <div v-if="model" class="mt-5">
      <div class="flex justify-between">
        <div class="flex">
          <div class="flex w-96">
            <thumbnail
              :size="''"
              :url="model.thumbnailUrl"
              :defaultIcon="false"
              :customCss="'mr-6 w-24 h-24 bg-layout md:w-28 md:h-28'"
              :borderWidth="1"
              :borderColor="'#c0c2c4'"
              :round="'5px'"
            >
              <template v-slot:default-icon
                ><i class="flex text-7xl fi fi-tr-cubes text-placeholder"></i
              ></template>
            </thumbnail>
            <div class="py-1">
              <div>
                <div class="text-desc text-md">
                  <span>사이즈:</span
                  ><span class="ml-1"
                    >{{ parseFloat(model.modelSizeX.toFixed(2)) }} x
                    {{ parseFloat(model.modelSizeY.toFixed(2)) }} x
                    {{ parseFloat(model.modelSizeZ.toFixed(2)) }}{{ model.modelUnit }}</span
                  >
                </div>
                <div class="mt-3 text-desc text-md">
                  <span>부피:</span
                  ><span class="ml-1">{{ numberToComma(model.modelVolume) }}㎜<sup>3</sup></span>
                </div>
              </div>
              <div class="mt-4">
                <button class="cs-btn cs-pd-btn-xs" :class="[classAnalysis]" @click="onShowViewer">
                  <div class="flex items-center">
                    <i class="fi fi-rr-cubes"></i>
                    <span class="mr-1 ml-1">자동분석 결과: </span
                    ><span class="">{{ totalAnalysis }}</span>
                  </div>
                </button>

                <div v-if="false" class="m-auto mt-2 cs-caption">
                  <i class="mr-1 fi fi-br-exclamation"></i>
                  <div class="text-left">
                    <p style="line-height: 1.3">
                      위 항목을 클릭하면 상세 내용을<br />확인할 수 있습니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mr-6 ml-6 border-l border-line"></div>
          <div class="w-60">
            <p class="text-sm text-desc">공정·재료</p>
            <div class="mt-1 mb-3 border-b border-line"></div>
            <dropdown
              :title="dropProcessTitle"
              :items="dropProcess"
              @onClick="onDropProcess"
            ></dropdown>
            <dropdown
              class="mt-3"
              :title="dropMaterialTitle"
              :items="dropMaterial"
              @onClick="onDropMaterial"
            ></dropdown>
            <div class="flex items-center mt-5">
              <label class="mr-5 form-check-label" for="pating">도색</label>
              <input
                class="form-check-input"
                id="pating"
                type="checkbox"
                :checked="model.modelPaint"
                @change="onChangePainting"
              />
            </div>
          </div>
          <div class="mr-6 ml-6 border-l border-line"></div>
          <div class="w-24">
            <p class="text-sm text-desc">수량</p>
            <div class="mt-1 mb-3 border-b border-line"></div>
            <div class="flex w-full cs-form" data-height="s">
              <input
                class=""
                v-model="modelCount"
                @input="onModelCount"
                @blur="onBlurModelCount"
                min="1"
                max="30"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                type="number"
              />
            </div>
          </div>
          <div class="mr-6 ml-6 border-l border-line"></div>
        </div>
        <div class="flex justify-end items-center">
          <div class="text-right">
            <!-- <div class="">
              <div></div>
              <div>
                <span class="mr-1 text-desc">단가</span>
                <span class="font-semibold text-desc">{{ numberToComma(model.modelCost) }}</span>
                원
              </div>
            </div> -->
            <div class="flex items-center">
              <span class="mr-3 text-1desc">단가</span>
              <!-- <span class="text-4xl font-bold">{{ numberToComma(model.modelCost * modelCount) }}원</span> -->
              <div class="inline-block w-28 cs-form" data-height="xs">
                <input
                  class="text-right"
                  v-model="modelCost"
                  type="text"
                  placeholder=""
                  @keyup="costNumberToComma(modelCost)"
                  @blur="costNumberToComma(modelCost)"
                />
              </div>
              <span class="ml-1">원</span>
            </div>
            <div class="mt-3 mb-3 border-b border-line"></div>
            <div class="flex justify-between items-center">
              <span class="mr-3 text-1desc">비용</span>
              <span class="text-4xl font-bold">{{ numberToComma(model.modelTotalCost) }}원</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="model.analysis && !model.analysis.length"
        class="justify-center items-center rounded-md bounding-loader"
      >
        <div class="loader-boxs">
          <div class="scene">
            <div class="plane">
              <div class="cube cube--0">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--0"></div>
              <div class="cube cube--1">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--1"></div>
              <div class="cube cube--2">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--2"></div>
              <div class="cube cube--3">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--3"></div>
              <div class="cube cube--4">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--4"></div>
              <div class="cube cube--5">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--5"></div>
              <div class="cube cube--6">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--6"></div>
              <div class="cube cube--7">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--7"></div>
            </div>
          </div>
        </div>
        <div class="text-center bounding-loader-text">
          <p class="text-lg font-semibold">업로드 및 분석 중 입니다, 잠시만 기다려주세요.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>

<script setup>
import {onMounted, ref, computed, watch} from "vue";
import {storeToRefs} from "pinia";
import axios from "axios";
import {CommonStore} from "../../store/common-store";
import {OptionsStore} from "../../store/options-store";
import {EstimateStore} from "../../store/estimate-store";
import {ModelStore} from "../../store/model-store";
import {AnalysisStatus, AnalysisStatusKo, Modals} from "../../js/types";
import {binaryToArrayBuffer, reqUploadModel} from "../../js/upload";
import {numberToComma, removeComma} from "../../js/utils";

import Dropdown from "../../components/DropDown.vue";
import Thumbnail from "../../components/ThumbnailBox.vue";

const {modalResult} = storeToRefs(CommonStore());
const optionsStore = OptionsStore();
const {processes, materials} = storeToRefs(optionsStore);
const estimateStore = EstimateStore();
const modelStore = ModelStore();

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["onShowCompanys", "update:selected"]);

const fileDownload = ref();

const currentPercent = ref(0);
const modelCount = ref(1);
const modelCost = ref("0");
const dropProcessTitle = ref("");
const dropMaterialTitle = ref("");

watch(modalResult, (newV) => {
  if (props.model.id !== newV.result.modelId) {
    return;
  }

  switch (newV.modalName) {
    case Modals.ModelTrash:
      modelStore.removeModel(props.model.id);
      break;
  }
});

watch(props.model, (newV) => {
  modelCost.value = numberToComma(newV.modelCost);
});

onMounted(async () => {
  modelCost.value = numberToComma(props.model.modelCost);

  if (!props.model.isUploaded) {
    const arrayBuffer = await binaryToArrayBuffer(props.model.file);
    if (arrayBuffer) {
      reqUploadModel(props.model, arrayBuffer, currentPercent);
    }
  } else {
    modelCount.value = props.model.modelCount;
    const processName = optionsStore.getProcessName(props.model.modelProcessId);
    if (processName) {
      dropProcessTitle.value = processName;
    }
  }

  let isSameMaterial = false;
  for (let m = 0; m < materials.value.length; m++) {
    const mate = materials.value[m];
    if (props.model.modelMaterialId === mate.id) {
      isSameMaterial = true;
      dropMaterialTitle.value = mate.name;
      break;
    }
  }

  if (!isSameMaterial) {
    modelStore.setModelMaterial(props.model.id, materials.value[0].id);
    dropMaterialTitle.value = materials.value[0].name;
    modelStore.reqActiveModel(props.model);
  }

  return;
});

/**********************************************
 * Computed
 *********************************************/
const classAnalysis = computed(() => {
  switch (props.model.modelAnalysis) {
    case AnalysisStatus.Fail:
      return "cs-btn-disabled";
    case AnalysisStatus.Warn:
      return "cs-btn-warn";
    case AnalysisStatus.Caution:
      return "cs-btn-caution";
    default:
      return "cs-btn-success";
  }
});
const totalAnalysis = computed(() => {
  if (AnalysisStatus.Processing === props.model.modelAnalysis) {
    return AnalysisStatusKo.Processing;
  }

  switch (props.model.modelAnalysis) {
    case AnalysisStatus.Fail:
      return AnalysisStatusKo.Fail;
    case AnalysisStatus.Warn:
      return AnalysisStatusKo.Warn;
    case AnalysisStatus.Caution:
      return AnalysisStatusKo.Caution;
    default:
      return AnalysisStatusKo.Pass;
  }
});
const dropProcess = computed(() => {
  const items = [];

  processes.value.forEach((val) => {
    items.push({
      title: val.name,
      data: val,
    });
  });

  return items;
});
const dropMaterial = computed(() => {
  const items = [];

  materials.value.forEach((val) => {
    if (props.model.modelProcessId === val.processId) {
      items.push({
        title: val.name,
        data: val,
      });
    }
  });

  return items;
});

/**********************************************
 * Event
 *********************************************/
const onDownload = () => {
  axios
    .post(`/models/${props.model.id}`, {
      key: props.model.modelKey,
      name: props.model.name,
    })
    .then((r) => {
      fileDownload.value.href = r.data.result.signedUrl;
      fileDownload.value.setAttribute("download", props.model.name);
      fileDownload.value.click();
    });
};
const onTrash = () => {
  const data = {
    modalName: Modals.ModelTrash,
    isShowCancel: false,
    title: "확인",
    content: "파일을 삭제하시겠습니까?",
    result: {
      modelId: props.model.id,
    },
  };
  CommonStore().showGlobalModal(data);
};
const onShowCompanys = () => {
  emit("onShowCompanys", props.model);
};
const onChangePainting = () => {
  modelStore.setModelPaint(props.model.id, !props.model.modelPaint);
  return;
};
const onModelCount = () => {
  if (!modelCount.value) {
    modelCount.value = 1;
  }
  if (30 < modelCount.value) {
    modelCount.value = 30;
  }
  modelStore.setModelCount(props.model.id, modelCount.value);
};
const onBlurModelCount = () => {
  if (!modelCount.value) {
    modelCount.value = 1;
  }
  if (30 < modelCount.value) {
    modelCount.value = 30;
  }
  modelStore.setModelCount(props.model.id, modelCount.value);
};
const onDropProcess = async (item) => {
  modelStore.setModelProcess(props.model.id, item.data.id);
  dropProcessTitle.value = item.name;

  for (let m = 0; m < materials.value.length; m++) {
    const mate = materials.value[m];
    if (props.model.modelProcessId === mate.processId) {
      dropMaterialTitle.value = mate.name;
      modelStore.setModelMaterial(props.model.id, mate.id);
      await modelStore.reqActiveModel(props.model);
      break;
    }
  }
};
const onDropMaterial = (item) => {
  dropMaterialTitle.value = item.data.name;
  modelStore.setModelMaterial(props.model.id, item.data.id);
  modelStore.reqActiveModel(props.model);
};
const onShowViewer = () => {
  modelStore.setCurrentModel(props.model);
};
const costNumberToComma = async (cost) => {
  if ("number" === typeof cost) {
    return;
  }

  if (cost.length) {
    modelCost.value = cost.replace(/[^0-9,]/g, "");
    modelCost.value = removeComma(modelCost.value);
    let num = Number.parseInt(modelCost.value);
    if (16000000 < num) {
      num = 16000000;
    }
    modelCost.value = numberToComma(num);
  } else {
    modelCost.value = "0";
  }

  await modelStore.setModelCost(props.model.id, Number.parseInt(removeComma(modelCost.value)));
  await estimateStore.calculateTotalCost();
};
</script>
